// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".diversity-list[data-v-84de3cd2]{padding-top:2em;display:grid;grid-gap:1em}@media (min-width:900px){.diversity-list[data-v-84de3cd2]{grid-template-columns:repeat(2,1fr)}}@media (min-width:1150px){.diversity-list[data-v-84de3cd2]{grid-template-columns:repeat(3,1fr)}}.diversity-item[data-v-84de3cd2]{padding:.5em;text-align:center;display:flex;flex-direction:column}", ""]);
// Exports
module.exports = exports;
